import React, { useCallback, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { levels as defaultLevels } from "../utils/levels";
import { useTranslation } from "react-i18next";
import { getQuiz } from "services/home";
import { useQuiz } from "providers/QuizProvider";
import "./css/levels.css";

const Levels = () => {
  const { activeQuiz, activeQuizLevel, updateActiveQuizLevel } = useQuiz();
  const navigate = useNavigate();
  const [levels, setLevels] = useState(defaultLevels);
  const { t } = useTranslation();

  const handleQuizClick = useCallback(
    (activeQuizLevelValue) => {
      updateActiveQuizLevel(activeQuizLevelValue);
    },
    [updateActiveQuizLevel]
  );

  useEffect(() => {
    if (activeQuiz?.id) {
      const levelPromises = defaultLevels.map((level) =>
        getQuiz(activeQuiz?.id, level.id, localStorage.getItem("selectedLanguage"))
      );
      Promise.all(levelPromises).then((res) => {
        setLevels(
          res.map((quiz, index) => ({
            ...defaultLevels[index],
            questions: quiz.length,
            points: quiz.length * defaultLevels[index].perQuestion
          }))
        );
      });
    }
  }, [activeQuiz?.id]);

  useEffect(() => {
    if (levels) {
      handleQuizClick(levels[0]);
    }
  }, [levels, handleQuizClick]);

  return (
    <div className="home level-page">
      <div className="main">
        <div className="container-fluid box-wrapper difficult">
          <div className="page-header pb-5">
            <div className="box-wrapper mx-auto text-center position-relative header-container">
              <button type="button" className="icon-button" onClick={() => navigate(-1)}>
                <img src="/image/back.png" className="arrow" alt="back" />
              </button>
              <span className="levels-title">{activeQuiz?.name}</span>
            </div>
          </div>
          <div className="quiz-thumbnail">
            <img src={activeQuiz?.image} alt="Quiz" />
          </div>
          <div className="home-profile">
            <div className="row gx-1">
              <div className="col-12">
                <h3 className="section-title2 mb-3">
                  {activeQuiz?.name} {t("15")}
                </h3>
              </div>
              <div className="col-12 quiz-info-meta-level">
                <span className="quiz-info-meta-circle-img">
                  <img src="/image/Group 19.png" alt="Quiz" />
                </span>
                <span className="title-gap">
                  {activeQuizLevel.questions} {t("16")}
                </span>
              </div>
            </div>
            <div className="quiz-info-content">
              <h4 className="quiz-info-content-title">{t("18")}</h4>
              <p>{activeQuiz?.description}</p>
            </div>
            <h3 className="choose-title mb-3">{t("21")}</h3>
            <div className="pb-2">
              <div
                className={`row gx-0 beginner-tab d-flex align-items-baseline ${
                  activeQuizLevel.id === 1 ? "active" : ""
                }`}
                onClick={() => handleQuizClick(levels[0])}
              >
                <div className="col-7 text-start">
                  <div className="d-flex align-items-baseline">
                    <div className="avatar2">
                      <img src="/image/Beginner.png" alt="level" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <div className="home-profile-name">{t("22")}</div>
                    </div>
                  </div>
                </div>
                <div className="col-5 text-end">
                  <div className="h-100 d-flex align-items-center justify-content-end">
                    <div className="home-profile-points">
                      <span className="points-text">
                        {" "}
                        {levels[0].points} {t("17")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pb-2">
              <div
                className={`row gx-0 intermediate-tab d-flex align-items-baseline ${
                  activeQuizLevel.id === 2 ? "active" : ""
                }`}
                onClick={() => handleQuizClick(levels[1])}
              >
                <div className="col-7 text-start">
                  <div className="d-flex align-items-baseline">
                    <div className="avatar2">
                      <img src="/image/Intermediate.png" alt="level" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <div className="home-profile-name">{t("23")}</div>
                      {/* <div className="home-profile-status">Guest</div> */}
                    </div>
                  </div>
                </div>
                <div className="col-5 text-end">
                  <div className="h-100 d-flex align-items-center justify-content-end">
                    <div className="home-profile-points">
                      <span className="points-text">
                        {" "}
                        {levels[1].points} {t("17")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div
                className={`row gx-0 advance-tab d-flex align-items-baseline ${
                  activeQuizLevel.id === 3 ? "active" : ""
                }`}
                onClick={() => handleQuizClick(levels[2])}
              >
                <div className="col-7 text-start">
                  <div className="d-flex align-items-baseline">
                    <div className="avatar2">
                      <img src="/image/Advance.png" alt="level" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <div className="home-profile-name">{t("24")}</div>
                      {/* <div className="home-profile-status">Guest</div> */}
                    </div>
                  </div>
                </div>
                <div className="col-5 text-end">
                  <div className="h-100 d-flex align-items-center justify-content-end">
                    <div className="home-profile-points">
                      <span className="points-text">
                        {" "}
                        {levels[2].points} {t("17")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <NavLink
                to="/finding"
                className={[
                  "btn btn-lg button-primary w-100",
                  activeQuizLevel.questions ? "" : "disabled"
                ].join(" ")}
              >
                {t("19")}
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Levels;
